import { render } from "./feed.vue?vue&type=template&id=d683d13c&scoped=true&lang=pug"
import script from "./feed.vue?vue&type=script&setup=true&lang=js"
export * from "./feed.vue?vue&type=script&setup=true&lang=js"

import "./feed.vue?vue&type=style&index=0&id=d683d13c&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d683d13c"]])

export default __exports__